import React from 'react';
import './ServiceDescription.scss';
import CommonButton from '../../../utility/components/CommonButton';
import { Link } from "react-router-dom";
import headerImage from '../../../assets/img/detailed-service-header.jpg';
import Accordion from '../../../utility/components/Accordion';
import TermsAndConditions from './../TermsAndConditions';
import CommencementDate from './../CommencementDate';
import CancellationPolicy from './../CancellationPolicy';

const ServiceDescription = ({ service }) => {
    if (!service) return <div className="error">Service data is not available</div>;
    
    const serviceImageSrc = require(`../../../assets/img/${service.ServiceImg}`);

    return (
        <>
            <div className="service-image-container">
                <div className="service-image" style={{ backgroundImage: `url(${headerImage})` }} />
                <h1 className="service-title">{service.ServiceName}</h1>
            </div>
            <section className="service-outer">
                <div className="service-detail">
                    <div className="service-body">
                        <div className="service-content-wrapper">
                            <div className="service-detail-image" style={{ backgroundImage: `url(${serviceImageSrc})` }} />
                            <div className="service-text-content">
                                <div className="service-price">
                                    {service.price.split('|').map((price, index) => (
                                        <p key={`price-${service.id}-${index}`}>{price.trim()}</p>
                                    ))}
                                </div>
                                <p className="service-details">{service.details}</p>
                                <h2 className="included-title">What's Included:</h2>
                                <ul className="included-list">
                                    {service.included.map((item) => (
                                        <li key={`included-${service.id}-${item}`}>{item}</li>
                                    ))}
                                </ul>
                            </div>
                        </div>
                        <div style={{margin: '32px 0'}}>
                            <Accordion title="Terms and Conditions"><TermsAndConditions /></Accordion>
                            <Accordion title="Commencement Date"><CommencementDate /></Accordion>
                            <Accordion title="Cancellation Policy"><CancellationPolicy /></Accordion>
                        </div>
                        <div className="button-container">
                            <Link to="/booking"><CommonButton>BOOK A SESSION</CommonButton></Link>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default ServiceDescription;